module.exports = __webpack_public_path__ + "img/98-202a7f.png";